import React from 'react';
import './Dialogs.css';

export const DeleteDialog = ({ onConfirm, onCancel }) => {
  return (
    <div className="dialog-overlay">
      <div className="dialog-content delete-dialog">
        <div className="dialog-header">
          <h3>Delete?</h3>
        </div>
        <div className="dialog-body">
          <p>
            <span className="ui-icon ui-icon-alert"></span>
            Are you sure you want to delete this record?
          </p>
        </div>
        <div className="dialog-buttons">
          <button className="btn btn-danger" onClick={onConfirm}>
            Yes
          </button>
          <button className="btn btn-default" onClick={onCancel}>
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export const SuccessDialog = ({ message, onClose }) => {
  React.useEffect(() => {
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="dialog-overlay">
      <div className="dialog-content success-dialog">
        <div className="dialog-body">
          <p>
            <span className="ui-icon ui-icon-circle-check"></span>
            {message}
          </p>
        </div>
        <div className="dialog-buttons">
          <button className="btn btn-success" onClick={onClose}>
            Ok
          </button>
        </div>
      </div>
    </div>
  );
};

export const ErrorDialog = ({ message, onClose }) => {
  return (
    <div className="dialog-overlay">
      <div className="dialog-content error-dialog">
        <div className="dialog-body">
          <p>
            <span className="ui-icon ui-icon-alert"></span>
            {message}
          </p>
        </div>
        <div className="dialog-buttons">
          <button className="btn btn-danger" onClick={onClose}>
            Ok
          </button>
        </div>
      </div>
    </div>
  );
};

export default { DeleteDialog, SuccessDialog, ErrorDialog };
